module.exports = __webpack_public_path__ + "static/media/boy-21.5a12438d.svg";